import { HttpResponse, delay, http } from 'msw';

import sampleFile from '../feedbackCenter/mockData/sample.pdf';
import { pdfResponse } from '../feedbackCenter/serverHandlers';
import { mockFeedbackRequest, mockJobDescription, mockResumeLink } from './mockData';

const {
	feedbackApi: { baseUrl },
	mockDelay,
} = global.config;

const feedbackHandlers = [
	http.get(encodeURIComponent('/resume-link'), () => pdfResponse(sampleFile)),
	http.get('/resume-link', () => pdfResponse(sampleFile)),
	http.get(`${baseUrl}/v1/api/email`, async ({ request }) => {
		await delay(mockDelay);

		const url = new URL(request.url);
		const linkId = url.searchParams.get('linkId');

		if (linkId === 'error') {
			return HttpResponse.error();
		}

		return HttpResponse.json(mockFeedbackRequest);
	}),

	http.post(`${baseUrl}/v1/api/email`, async ({ request }) => {
		await delay(mockDelay);

		const body = await request.json();

		if (body.feedbackState === 'error') {
			return HttpResponse.error();
		}

		return HttpResponse.json(null);
	}),

	http.get(`${baseUrl}/resume-link/:intervieweeId/customer/:customerId`, async ({ params }) => {
		await delay(mockDelay);
		const { intervieweeId } = params;

		if (intervieweeId === 'error') {
			return HttpResponse.error();
		}

		return HttpResponse.json(mockResumeLink);
	}),

	http.get(`${baseUrl}/job-description/:jobId/customer/:customerId`, async ({ params }) => {
		await delay(mockDelay);

		const { jobId } = params;
		if (jobId === 'error') {
			return HttpResponse.error();
		}
		return HttpResponse.json(mockJobDescription);
	}),
];

export const handlers = [...feedbackHandlers];
